import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'
import ChevronLeft from '../../../images/icon_chevron_left_white.svg'
import ChevronRight from '../../../images/icon_chevron_right_white.svg'

const size_icon_mobile = '40px'
const size_icon_desktop = '2.3em'
const size_iconPadding = '0.1em'

export const StyledItem = styled.button`
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  min-width: 60px;
  max-width: 70px;
  padding: 4px 0 4px;
  gap: 7px;
  * {
    padding: 0;
  }
`

export const StyledItemIcon = styled.img`
  background: ${themeStyles.colors.darkGreys[5].main};
  box-sizing: border-box;
  width: ${size_icon_mobile};
  height: ${size_icon_mobile};
  padding: ${size_iconPadding};
  border-radius: 10px;
`

export const StyledItemLabel = styled.label`
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  font-size: 0.5em;
  font-weight: 400;
  color: ${themeStyles.colors.white.main};
  height: 1.2em;
  line-height: 1.1em;

  &,
  > * {
    white-space: initial;
  }
`

export const StyledScrollButton = styled.button`
  display: block;
  position: absolute;
  top: 0;

  z-index: 10;
  height: 100%;
  width: 24px;
  background: ${themeStyles.colors.black.main}48;
  background-position: center;
  background-size: 0.6em;
  background-repeat: no-repeat;
  transition: 0.5s;

  ${(props) =>
    props.isRight ?
      css`
          right: ${props.hide ? -100 : 0}px;
          background-image: url('${ChevronRight}');
        ` :
      css`
          left: ${props.hide ? -100 : 0}px;
          background-image: url('${ChevronLeft}');
        `}
`

export const StyledOuterSportMenuWrapper = styled.section`
  position: relative;
`

export const StyledInnerSportMenuWrapper = styled.div`
  display: flex;
  padding: 0;
  background-color: ${themeStyles.colors.darkGreys[4].main};
  overflow-y: hidden;
  overflow-x: auto;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  ${(props) =>
    props.isDesktop &&
    css`
      // overflow: hidden;

      ${StyledItem} {
        padding: 9px 0 13px;
        gap: 6px;
        min-width: 70px;
        max-width: 70px;
      }

      ${StyledItemIcon} {
        width: ${size_icon_desktop};
        height: ${size_icon_desktop};
      }

      ${StyledItemLabel}
    `}
`
